import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _excluded = ["styles", "makeStyles"];
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@instructure/ui-checkbox';
import { Text } from '@instructure/ui-text';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import OutcomeCheckbox from "../OutcomeCheckbox/index.js";
import { outcomeShape, stylesShape } from "../../store/shapes.js";
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
var OutcomeSelectionList = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeSelectionList, _React$Component);
  var _super = _createSuper(OutcomeSelectionList);
  function OutcomeSelectionList() {
    _classCallCheck(this, OutcomeSelectionList);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomeSelectionList, [{
    key: "allSelected",
    value: function allSelected() {
      var _this$props = this.props,
        outcomes = _this$props.outcomes,
        isOutcomeSelected = _this$props.isOutcomeSelected;
      return outcomes.every(function (o) {
        return isOutcomeSelected(o.id);
      });
    }
  }, {
    key: "toggleAllSelected",
    value: function toggleAllSelected() {
      var _this$props2 = this.props,
        deselectOutcomeIds = _this$props2.deselectOutcomeIds,
        selectOutcomeIds = _this$props2.selectOutcomeIds,
        outcomes = _this$props2.outcomes;
      var ids = outcomes.map(function (o) {
        return o.id;
      });
      if (this.allSelected()) {
        deselectOutcomeIds(ids);
      } else {
        selectOutcomeIds(ids);
      }
    }
  }, {
    key: "selectAllText",
    value: function selectAllText() {
      if (this.allSelected()) {
        return t('Deselect all');
      } else {
        return t('Select all');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props3 = this.props,
        outcomes = _this$props3.outcomes,
        setFocusedOutcome = _this$props3.setFocusedOutcome;
      var _this$props4 = this.props,
        styles = _this$props4.styles,
        makeStyles = _this$props4.makeStyles,
        restProps = _objectWithoutProperties(_this$props4, _excluded);
      if (outcomes.length === 0) {
        return jsx("div", null);
      }
      return jsx("div", {
        css: this.props.styles.picker,
        "data-automation": "outcomeSelectionList__picker"
      }, jsx("div", {
        css: this.props.styles.checkbox
      }, jsx(Checkbox, {
        value: "selectAll",
        checked: this.allSelected(),
        onChange: function onChange() {
          return _this.toggleAllSelected();
        },
        label: jsx("div", {
          css: this.props.styles.checkboxLabel
        }, jsx(Text, {
          size: "small"
        }, this.selectAllText()))
      })), outcomes.map(function (o) {
        return jsx("div", {
          key: o.id
        }, jsx(OutcomeCheckbox, Object.assign({
          outcome: o,
          setFocusedOutcome: setFocusedOutcome
        }, restProps)));
      }));
    }
  }]);
  OutcomeSelectionList.displayName = "OutcomeSelectionList";
  return OutcomeSelectionList;
}(React.Component), _class2.propTypes = {
  setFocusedOutcome: PropTypes.func.isRequired,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  outcomes: PropTypes.arrayOf(outcomeShape).isRequired,
  styles: stylesShape
}, _class2)) || _class);
export { OutcomeSelectionList as default };